import {
  API,
  Request
} from '@/lib/index.js'

export default {
  namespaced: true,
  state: {
    userRating: {},
    averageRating: {},
  },
  mutations: {
    noAction () {},
    updateUserRating (state, payload) {
      state.userRating = payload
    },
    updateAverageRating (state, payload) {
      state.averageRating = payload
    },
  },
  getters: {

  },
  actions: {
    queryUserRating ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryUserRating, {
          courseId: payload.courseId
        }).then((resp) => {
          resolve(resp)
          commit('updateUserRating', resp)
        }).catch(() => {
          reject()
        })
      })
    },
    submitRating ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.submitRating, {
          request: {
            courseId: payload.courseId,
            score: payload.score,
            dissatisfiedReasons: payload.dissatisfiedReasons
          }
        }).then((resp) => {
          resolve(resp)
          commit('updateUserRating', {
            courseId: payload.courseId,
            score: payload.score,
            dissatisfiedReasons: payload.dissatisfiedReasons
          })
        }).catch(() => {
          reject()
        })
      })
    },
    queryAverageRating ({commit}, payload) {
      return new Promise((resolve, reject) => {
        Request(API.queryAverageRating, payload).then((resp) => {
          resolve(resp)
          commit('updateAverageRating', resp)
        }).catch(() => {
          reject()
        })
      })
    }
  }
}